module.exports = __webpack_public_path__ + "Linearicons-Free.65060723fe964f85afa0";


//////////////////
// WEBPACK FOOTER
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/assets/vendors/by_hands/font-linearicons/fonts/Linearicons-Free.woff?w118d
// module id = ../../../../../src/assets/vendors/by_hands/font-linearicons/fonts/Linearicons-Free.woff?w118d
// module chunks = styles